var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4762 3.69922H22V5.83255H10.4762V3.69922ZM10.4762 7.96589H22V10.0992H10.4762V7.96589ZM0 12.2326H22V14.3659H0V12.2326Z",
    fill: "#3A99FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2076 7.83815C6.96664 9.16615 6.41141 10.0995 5.76188 10.0995C5.11236 10.0995 4.55712 9.16721 4.31617 7.83815C3.01188 7.59281 2.09521 7.02748 2.09521 6.36615C2.09521 5.70481 3.01083 5.13948 4.31617 4.89415C4.55712 3.56615 5.11236 2.63281 5.76188 2.63281C6.41141 2.63281 6.96664 3.56508 7.2076 4.89415C8.51188 5.13948 9.42855 5.70481 9.42855 6.36615C9.42855 7.02748 8.51293 7.59281 7.2076 7.83815Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4816 7.09895C6.41455 8.80881 6.11807 10.0995 5.76188 10.0995C5.40569 10.0995 5.10922 8.80881 5.04217 7.09895C3.36283 7.03068 2.09521 6.72881 2.09521 6.36615C2.09521 6.00348 3.36283 5.70161 5.04217 5.63335C5.10922 3.92348 5.40569 2.63281 5.76188 2.63281C6.11807 2.63281 6.41455 3.92348 6.4816 5.63335C8.16093 5.70161 9.42855 6.00348 9.42855 6.36615C9.42855 6.72881 8.16093 7.03068 6.4816 7.09895Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M5.76186 7.96758C6.62973 7.96758 7.33329 7.25123 7.33329 6.36758C7.33329 5.48392 6.62973 4.76758 5.76186 4.76758C4.89398 4.76758 4.19043 5.48392 4.19043 6.36758C4.19043 7.25123 4.89398 7.96758 5.76186 7.96758Z",
    fill: "#FFDA2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.07a2f102065356cd206ab4953f88efca.svg";
export { ForwardRef as ReactComponent };